import styled from 'styled-components';

export const FieldPhoneContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;
